import { BaseModel } from '@/api/base-model'
import { RealworksKenmerkAPI } from '@/api/backend-client'

export class RealworksKenmerk extends BaseModel<RealworksKenmerk> {
    protected collectionName = RealworksKenmerkAPI.collectionName

    constructor(
        public id: string,
        public groep: string,
        public omschrijving: string,
        public actief: boolean,
    ) {
        super(id)
    }

    static fromData(data: any) {
        return new RealworksKenmerk(
            data.id,
            data.company,
            data.omschrijving,
            data.actief,
        )
    }
}
